export default "__VITE_PUBLIC_ASSET__6ae7dfb6__"